import { useLogicStore } from "@/stores/use-conditional-logic-store"
import { parseAttributes } from "../../lib/utils"
import {
	RichTextConfig,
	type Attribute,
	type FIELD,
} from "../../types/form-types"

interface RichTextProps {
	field: FIELD
}

export const RichText = ({ field }: RichTextProps) => {
	const { content } = getRichTextAttributes(field.attributes)
	const { hiddenFields } = useLogicStore()

	if (hiddenFields[field.field_id]) return null

	return (
		<div
			className="rich-text"
			dangerouslySetInnerHTML={{ __html: content }}
		/>
	)
}

function getRichTextAttributes(attributes: Attribute[]) {
	const props: {
		content: string
	} = {
		content: "",
	}

	const parsedAttributes = parseAttributes(attributes)

	Object.entries(parsedAttributes).forEach(([key, value]) => {
		switch (key) {
			case RichTextConfig.Content:
				props.content = value as string
				break
		}
	})

	return props
}
